export const ScoreRing = ({ score = 0, size = 74 }) => {
  const r = (size - 10) / 2;
  const circ = 2 * Math.PI * r;
  const color = score >= 70 ? "#00E676" : score >= 60 ? "#FFC107" : "#FF4C4C";
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#1c2330" strokeWidth="6" />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none"
          stroke={color} strokeWidth="6" strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={circ * (1 - score / 100)}
          style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.16,1,0.3,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono text-xl font-bold leading-none" style={{ color }}>{score}</span>
        <span className="font-mono text-[8px] text-mute-dim">/100</span>
      </div>
    </div>
  );
};
